module.exports = __webpack_public_path__ + "static/media/animation-game-banner.102cdd51.jpg";